<template>
  <div>
    <div
      v-if="renderDom[0].type === 'need'"
      :class="'custom-message ' + (isMine ? 'my-custom' : '')"
    >
      <div class="custom-content">
        <div class="custom-order-title">
          {{ renderDom[0].title }}
        </div>
        <div class="custom-content-description">
          需求类目：{{ renderDom[0].categories }}
        </div>
        <div class="custom-content-description">
          教学方式：{{
            renderDom[0].service_type == 2 ? "上门教学" : "到店上课"
          }}
        </div>
        <div class="custom-content-query" @click="toDetails">需求</div>
      </div>
    </div>
    <div
      v-if="renderDom[0].type === 'order'"
      :class="'custom-message ' + (isMine ? 'my-custom' : '')"
    >
      <div class="custom-content">
        <div class="custom-order">
          <img src="/static/logo.png" class="custom-order-logo" />
          <div class="custom-order-text">
            <div class="custom-order-title">
              {{ renderDom[0].title }}
            </div>
            <div class="">
              {{ renderDom[0].service_type == 2 ? "上门教学" : "到店上课" }}
            </div>
            <div class="custom-order-price">￥{{ renderDom[0].amount }}</div>
          </div>
        </div>

        <div class="custom-content-query" @click="toDetails">订单</div>
      </div>
    </div>
    <div v-if="renderDom[0].type === 'course'">
      <div class="course-msg flex" @click="toDetails">
        <div class="">
          <img :src="renderDom[0].face_url" class="course-img" />
        </div>
        <div class="flex-1">
          <div class="course-title">
            {{ renderDom[0].title }}
          </div>
          <div class="flex j-b c-p">
            ￥{{ renderDom[0].amount }}
            <div class="c-btn">详情</div>
          </div>
          <div class="c-tag">
            {{ renderDom[0].categories + " " }}
            {{ renderDom[0].course_num }}节
          </div>
        </div>
      </div>
    </div>
    <div v-if="renderDom[0].type === 'expert'">
      <div class="course-msg flex" @click="toCoachDetails">
        <div class="">
          <img :src="renderDom[0].head_portrait" class="course-img" />
        </div>
        <div class="flex-1">
          <div class="course-title">
            {{ renderDom[0].name }}
          </div>
          <div class="flex j-b c-p">
            ￥{{ renderDom[0].min_price }}
            <div class="c-btn">详情</div>
          </div>
          <div class="c-tag">
            {{ renderDom[0].teaching_categories + " " }}
            {{ renderDom[0].city }}
          </div>
        </div>
      </div>
    </div>


    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <el-descriptions title="信息" :column="1">
        <el-descriptions-item label="标题">
          {{ extensionInfo.title }}
        </el-descriptions-item>
        <el-descriptions-item label="类目">
          {{ extensionInfo.categories }}
        </el-descriptions-item>
        <el-descriptions-item label="金额">
          {{ extensionInfo.amount }}
        </el-descriptions-item>
        <el-descriptions-item label="服务方式">
          {{ service[extensionInfo.service_type] }}
        </el-descriptions-item>
      </el-descriptions>
      <el-button type="primary" @click="toNeedDetails">全部信息</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { formateTime } from "../../../base/common.js";
export default {
  data() {
    return {
      dialogVisible: false,
      extensionInfo: {},
      service: {
        1: "海马场地",
        2: "上门教学",
        3: "教练场地",
      },
      base: {
        1: "零基础",
        2: "初入门",
        3: "中级",
        4: "高级",
      },
    };
  },
  components: {},
  props: {
    message: {
      type: Object,
      default: () => {},
    },
    isMine: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    message: {
      handler: function (newVal) {
        this.message = newVal;
        this.renderDom = this.parseCustom(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toCoachDetails(){
      this.$router.push({
        name: "coachDetails",
        query: { id: this.renderDom[0].id },
      });
    },
    toDetails() {
      this.extensionInfo = JSON.parse(this.message.payload.extension);
      this.dialogVisible = true;
    },
    toNeedDetails() {
      this.dialogVisible = false;
      this.$router.push({
        name: "courseNeedDetails",
        query: { id: this.extensionInfo.id },
      });
    },

    toNeed() {
      uni.navigateTo({
        url: "/pages/timMessage/details/needDetails?id=" + this.renderDom[0].id,
      });
    },
    toOrder() {
      uni.navigateTo({
        url:
          "/pages/timMessage/details/orderDetails?id=" + this.renderDom[0].id,
      });
    },
    parseCustom(message) {
      // 约定自定义消息的 data 字段作为区分，不解析的不进行展示
      if (message.payload.data === "need") {
        const extension = JSON.parse(message.payload.extension);
        const renderDom = [
          {
            type: "need",
            name: "custom",
            id: extension.id,
            title: extension.title || "",
            categories: extension.categories || "",
            course_num: extension.course_num || 0,
            service_type: extension.service_type || 1,
          },
        ];
        return renderDom;
      } else if (message.payload.data === "order") {
        const extension = JSON.parse(message.payload.extension);
        const renderDom = [
          {
            type: "order",
            name: "custom",
            id: extension.id,
            amount: extension.amount,
            categories: extension.categories,
            title: extension.title,
            service_type: extension.service_type,
          },
        ];
        return renderDom;
      } else if (message.payload.data === "course") {
        const extension = JSON.parse(message.payload.extension);
        const renderDom = [
          {
            type: "course",
            name: "custom",
            title: extension.title || "",
            id: extension.id || "",
            course_type: extension.course_type || "",
            categories: extension.categories || "",
            course_num: extension.course_num || "",
            address: extension.address || "",
            amount: extension.amount || "",
            face_url: extension.face_url || "",
          },
        ];
        return renderDom;
      }else if (message.payload.data === 'expert') {
				const extension = JSON.parse(message.payload.extension);
				const renderDom = [
					{
						type: 'expert',
						...extension
					}
				];
				return renderDom;
			} else {
        const extension = message.payload.extension;
        const renderDom = [
          {
            type: message.payload.data,
            name: "custom",
            title: extension || "",
          },
        ];
        return renderDom;
      }
    },
  },
};
</script>
<style lang="less">
.custom-message {
  display: flex;
  padding: 20px 24px 10px;
  background-color: #fff;
  border-radius: 2px 10px 10px 10px;
}

.my-custom {
  border-radius: 10px 2px 10px 10px;
}

.custom-content-title {
  font-family: PingFangSC-Medium;
  width: 400px;
  line-height: 2;
  font-size: 13px;
  color: #333;
  letter-spacing: 0;
  margin-bottom: 12px;
}

.custom-content-description {
  font-family: PingFangSC-Regular;
  width: 400px;
  line-height: 1.5;
  font-size: 13px;
  color: #333;
  letter-spacing: 0;
  margin-bottom: 6px;
}

.custom-content-price {
  font-family: PingFangSC-Medium;
  line-height: 50px;
  color: #ff7201;
  letter-spacing: 0;
}
.custom-content-query {
  border-top: 2px solid #e4e4e4;
  color: #ff7201;
  text-align: center;
  line-height: 2;
  margin-top: 20px;
  font-size: 14px;
}
.custom-image {
  width: 135px;
  height: 135px;
  border-radius: 6px;
  margin-right: 10px;
  margin-top: 4px;
}

.custom-content-score {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
}

.custom-content-score .score-star {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}

.my-text {
  border-radius: 10px 2px 10px 10px;
  border: 1px solid rgba(0, 110, 255, 0.3);
  background: rgba(0, 110, 255, 0.1);
}

.message-body-span {
  display: flex;
  justify-content: center;
  align-items: center;
  /*justify-content: flex-start;*/
  flex-wrap: wrap;
  outline: none;
  font-size: 28px;
  color: #333333;
  position: relative;
  max-width: 60vw;
}

.message-body-span-text {
  width: 100%;
  display: inline;
  word-wrap: break-word;
  word-break: break-all;
}

.custom-content-text {
  font-family: PingFangSC-Regular;
  height: 25px;
  line-height: 25px;
  font-size: 28px;
  letter-spacing: 0;
}

.custom-order {
  display: flex;
}

.custom-order-logo {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.custom-order-text {
  width: 260px;
  color: #333;
  font-size: 12px;
}
.custom-order-title {
  font-size: 14px;
  margin-bottom: 10px;
}
.custom-order-price {
  color: #ff7201;
  font-size: 14px;
}
.course-msg {
  padding: 10px;
  background-color: #fff;
  border-radius: 2px 10px 10px 10px;
  border: 1px solid #d9d9d9;
  width: 500px;
  position: relative;
}
.course-img {
  width: 140px;
  height: 140px;
  margin-right: 16px;
}

.course-title {
  font-size: 30px;
}
.c-p {
  font-size: 34px;
  color: #ff7201;
}
.c-btn {
  position: absolute;
  top: 60px;
  right: 20px;
  padding: 0 28px;
  height: 50px;
  box-sizing: border-box;
  line-height: 50px;
  text-align: center;
  background-color: #fc7819;
  border-radius: 30px;
  color: #fff;
  font-size: 24px;
}
.c-tag {
  font-size: 26px;
  color: #b6b6b6;
}
</style>
